import { createApiInstance } from './interceptors';

const api = createApiInstance();

const silentApi = createApiInstance();
silentApi.interceptors.request.use(
    (config) => { config.headers['Skip-Loader'] = true; return config; },
);

export { silentApi };
export default api;
